import { Component, Renderer2, Inject, DOCUMENT, signal } from "@angular/core";
import { Router, Event, NavigationEnd, ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";

import { AbstractComponent } from "../abstract/abstract.component";
import { NgIf } from "@angular/common";

@Component({
    selector: "kilowant-footer",
    templateUrl: "../../../html/incs/footer.html",
    imports: [NgIf]
})
export class FooterComponent extends AbstractComponent {
    isHome: boolean = false;

    currentYear = signal<number>(new Date().getFullYear());

    constructor(router: Router,
        dialog: MatDialog,
        route: ActivatedRoute,
        private renderer: Renderer2,
        analyticsService: AnalyticsService,
        generalService: GeneralService,

        @Inject(DOCUMENT) private _document: Document) {

        super(router, route, dialog, analyticsService, generalService);
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                if (this.getRequestURL() == "/") {
                    this.isHome = true;
                } else {
                    this.isHome = false;
                }                
            }
        });
    }

    ngOnInit(): void {
        super.ngOnInit();
    }
    pageStart(): void {
        var y = this.currentDate.year;
        if (y < 2021) {
            y = 2021;
        }
    }
    ngAfterViewInit(): void {
        let script = this.renderer.createElement("script");
        script.type = `text/javascript`;
        script.text = `
                {
                   var __dcid = __dcid || [];
                   __dcid.push({"cid":"DigiCertClickID_2oan2RkY","tag":"2oan2RkY"});
                   (function(){var cid=document.createElement("script");cid.async=true;cid.src="//seal.digicert.com/seals/cascade/seal.min.js";var s = document.getElementsByTagName("script");var ls = s[(s.length - 1)];ls.parentNode.insertBefore(cid, ls.nextSibling);}());
                }
             `;
        this.renderer.appendChild(this._document.body, script);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    getRequestURL(): string {
        let url = this.router.parseUrl(this.router.url);
        url.queryParams = {};
        url.fragment = null;
        return url.toString();
    }

    gotoLogin(): void {
        this.router.navigate(["/user/login"]);
    }
}